// core
import {
  Component, OnInit, Input, ElementRef, AfterViewInit
} from '@angular/core';

import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  selector: 'open-button-toggle',
  templateUrl: './open-button-toggle.component.html',
  styleUrls: ['./open-button-toggle.component.scss']
})
export class OpenButtonToggleComponent implements OnInit, AfterViewInit {
  @Input() form: any;
  @Input() question: any;
  
  questionControl: any;

  constructor(
    private element: ElementRef,
  ) { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);
  }

  ngAfterViewInit() {
    this.setActiveDisplay();
    window.addEventListener('resize', this.resizeListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  resizeListener = () => {
    requestAnimationFrame(() => {
      this.setActiveDisplay();
    });
  };

  setActiveDisplay(event?: MatButtonToggleChange): void {
    let activeWidth = 0;
    let activeLeft = 0;
    let activeElement;
    const toggleGroup = this.element.nativeElement.querySelector('.mat-button-toggle-group');

    // Get the relevant active button
    if (event !== undefined) {
      // eslint-disable-next-line no-underscore-dangle
      activeElement = event.source._buttonElement.nativeElement.parentElement;
    } else {
      activeElement = this.element.nativeElement.querySelector('.mat-button-toggle-checked');
    }
    
    if (activeElement) {
      activeWidth = activeElement.offsetWidth;
      activeLeft = activeElement.offsetLeft;
    }

    if (toggleGroup) {
      toggleGroup.style.setProperty('--widthJS', `${activeWidth}px`);
      toggleGroup.style.setProperty('--transformJS', `${activeLeft}px`);
    }
  }

  buttonToggleClasses(): any {
    const classes: any = {
      'switch': this.question?.settings?.style === 'slide-toggle',
      'boolean-buttons': this.isBooleanQuestion(this.question) === true,
      'two-buttons': this.isBooleanQuestion(this.question) === false && this.question?.settings?.choices.length === 2,
      'small': this.question?.settings?.size === 'small',
      'medium': this.question?.settings?.size === 'medium',
      'large': this.question?.settings?.size === 'large',
      'text-left': !this.question.settings || !this.question?.settings?.align || this.question?.settings?.align === 'left',
      'text-center': this.question?.settings?.align === 'center',
      'text-right': this.question?.settings?.align === 'right',
      'dark-background': this.question?.settings?.background === 'dark',
      'width-fluid': this.question?.settings?.width === 'fluid',
      'width-fill-space': !this.question?.settings?.width || this.question?.settings?.width === 'fill-space'
    };

    return classes;
  }

  public isBooleanQuestion(question: any) {
    const choices = question?.settings?.choices;
    let hasTrue;
    let hasFalse;

    if (choices && choices.length === 2) {
      hasTrue = choices[0].value === true || choices[1].value === true;
      hasFalse = choices[0].value === false || choices[1].value === false;
    }

    return hasTrue && hasFalse;
  }
}
